export default __webpack_public_path__ + "static/char-s-sp01-en-6deab562e1e68aa85648ff2c246e3f98.webp";